import React from 'react';

import classNames from 'classnames';

import { InfoIcon } from 'features/order-tracker/shared-components/svg';

import { ANALYTICS_APPT_SELECTED, NO_AVAILABLE_SLOTS_MESSAGE } from '../../constants';

import styles from './styles.module.scss';

export const DayWithSlots: React.FC<components.DaysWithSlots> = (props) => {
  const { title, availableSlots, selectSlot, selectedSlot, dateInfo } = props;
  const hasNoSlots = !availableSlots.length;

  return (
    <div className={classNames(styles.dayInfoContainer, { [styles.noSlotsAvailable]: hasNoSlots })}>
      <InfoIcon className={styles.infoIcon} />
      <h5>{title}</h5>
      {hasNoSlots ? (
        <p>{NO_AVAILABLE_SLOTS_MESSAGE}</p>
      ) : (
        <div className={styles.slotsContainer}>
          {availableSlots.map((slot) => {
            const slotID = `${title} ${slot.split('-')[1]}`;
            const date = new Date(dateInfo);
            date.setHours(parseInt(slot.split('-')[1], 10));
            return (
              <button
                key={slotID}
                onClick={() => selectSlot(slotID, date)}
                className={classNames(styles.availableSlot, { [styles.selected]: selectedSlot === slotID })}
                data-analytics-link={ANALYTICS_APPT_SELECTED}
                type="button"
              >
                {slot}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
